import React from "react";
import "./S3VI.css";
import bgImage from "../../assets/S1BG.png";
import Ontario from "../../assets/Ontario.PNG";
import BritishColumbia from "../../assets/BC.jpg";
import Alberta from "../../assets/Alberta.PNG";
import Quebec from "../../assets/Quebec.png";
import NovaScotia from "../../assets/Nova Scotia.PNG";
import Manitoba from "../../assets/Manitoba.PNG";
import Saskatchewan from "../../assets/Saskatchewan.PNG";
import NewBrunswick from "../../assets/New Brunswick.PNG";
import Newfoundland from "../../assets/Newfoundland.png";
import PrinceEdwardIsland from "../../assets/Prince Edward.png";

const items = [
  { title: "Ontario", src: Ontario },
  { title: "British Columbia", src: BritishColumbia },
  { title: "Alberta", src: Alberta },
  { title: "Quebec", src: Quebec },
  { title: "Nova Scotia", src: NovaScotia },
  { title: "Manitoba", src: Manitoba },
  { title: "Saskatchewan", src: Saskatchewan },
  { title: "New Brunswick", src: NewBrunswick },
  { title: "Newfoundland", src: Newfoundland },
  { title: "Prince Edward Island", src: PrinceEdwardIsland },
];

const S3VI = () => {
  return (
    <section
      className="s3vi"
      style={{ backgroundImage: `url(${bgImage})` }}
      aria-labelledby="s3vi-heading"
    >
      <div className="s3vi-inner">
        <h2 id="s3vi-heading" className="s3vi-heading">
          A platform to explore markets across Canada
        </h2>

        <div className="s3vi-grid">
          {items.map((it) => {
            // Build URL from title
            const provinceSlug = it.title.toLowerCase().replace(/\s+/g, "-");
            const link = `https://www.maplee.ca/province/${provinceSlug}`;

            return (
              <a
                key={it.title}
                href={link}
                className="s3vi-card"
              >
                <div className="s3vi-card-media">
                  <img src={it.src} alt={it.title} loading="lazy" />
                </div>
                <div className="s3vi-card-title">{it.title}</div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default S3VI;